import request from '@/utils/request'

// 商户分页（按当前登录员工）
export const getStorePageByEmp = (params: any) => {
  return request({
    url: '/store/pageByEmpId',
    method: 'get',
    params
  })
}

// 新增商户
export const addStore = (data: any) => {
  return request({
    url: '/store',
    method: 'post',
    data: { ...data }
  })
}

// 修改商户
export const updateStore = (data: any) => {
  return request({
    url: '/store',
    method: 'put',
    data: { ...data }
  })
}

// 删除商户
export const deleteStore = (id: string | number) => {
  return request({
    url: '/store',
    method: 'delete',
    params: { id }
  })
}

// 查询商户详情
export const getStoreInfo = (id: string | number) => {
  return request({
    url: '/store/info',
    method: 'get',
    params: { id }
  })
}

// 查询当前员工下的所有商户（不分页，可用于下拉选择）
export const listMyStores = () => {
  return request({
    url: '/store/listByEmp',
    method: 'get'
  })
}
